import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// @material-ui/icons
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import moment from "moment";

import { DatePicker } from "@material-ui/pickers";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";
import MenuTypeTimetableContainer from "container/componentsCustom/MenuTypeTimetableContainer.js";
// import Item from "componentsCustom/ListItem/Item";
import ItemTicketType from "componentsCustom/ListItem/ItemTicketType";
import { useHistory } from "react-router-dom";
// import pathSplit from "util/pathSplit";
// import getTicketsType from "api/getTicketsType";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import LeftSideMuseumInfoTickets from "../componentsCustom/Museum/LeftSideMuseumInfoTickets";
import styles from "./EventList.module.css";
import NavBarEvent from "../componentsCustom/EventList/NavBarEvent";
import { Hidden /*, Typography */ } from "@material-ui/core";
// import logo from "../assets/img/logo.png";
// import DateTimeInputSection from "../componentsCustom/EventList/DateTimeInputSection";
import Button from "../components/CustomButtons/Button";
import getSlot from "../api/getSlot";

// import getEventi from "api/getEventi";

const useStyles = makeStyles(menuStyle);

export default function BaseEventList(props) {
  const {
    updateCart,
    cart,
    language,
    museum,
    currency,
    customStyle,
    // updateShippingInfo,
    // updateCartParams,
    shippingInfo,
    cartParams,
    articles,
    // updateEventSelected,
    eventSelected,
  } = props;

  const history = useHistory();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const [list, setList] = useState([]);
  const [, setCategories] = useState([]);

  // eslint-disable-next-line
  const [showAddItem, setShowAddItem] = useState(false);
  const [waiting, setWaiting] = useState(false);
  // eslint-disable-next-line
  const [selectItem, setSelectedItem] = useState({});
  // eslint-disable-next-line
  const [showAlert, setShowAlert] = useState(true);
  const [slots, setSlots] = useState(null);
  // const [ticketsType, setTicketsType] = useState([]);
  const [openings, setOpenings] = useState({});
  const [dateTimeSelected, setDateTimeSelected] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  // const [availablePlaces, setAvailablePlaces] = useState(null);
  // eslint-disable-next-line
  const [showPlacesWarning, setShowPlacesWarning] = useState(false);
  const [isOpen] = useState("");

  useEffect(() => {
    // console.log("ART", articles);
    if (articles && articles[0] && articles.length > 0) {
      const categoriesArray = articles.map((el) => {
        return {
          codici_sconto: el.codici_sconto,
          id: el.id,
          nome_categoria: el.nome_categoria,
        };
      });

      setList(articles);
      setCategories(categoriesArray);
    }
  }, [articles]);

  useEffect(() => {
    if (museum.organisation) {
      setWaiting(true);
      getSlot(
        museum.organisation.id,
        moment(dateTimeSelected).format("YYYY-MM-DD")
      )
        .then((newSlots) => {
          //If the date selected is today, list only the slots after now
          var now = new Date();
          if (dateTimeSelected > now) {
            setSlots(newSlots);
          } else {
            var i;
            var correctSlots = [];
            const hoursAndMinutes = now.getHours() + ":" + now.getMinutes();
            for (i = 0; i < newSlots.length; i++) {
              if (newSlots[i] > hoursAndMinutes) {
                correctSlots.push(newSlots[i]);
              }
            }
            setSlots(correctSlots);
          }

          setWaiting(false);
        })
        .catch((err) => {
          // console.log("error while requesting time", err);
        });
    }
  }, [dateTimeSelected, museum]);

  useEffect(() => {
    if (museum && museum.orari_museo) {
      setOpenings(museum.orari_museo);
    }
  }, [museum]);

  useEffect(() => {
    // eslint-disable-next-line
    if (shippingInfo && shippingInfo.date) {
      setShowAlert(false);
    }
  }, [shippingInfo]);

  const classes = useStyles();

  const { t } = useTranslation();

  // const [alertProps] = useState({
  //   title: t("select_date_title"),
  //   description: t("select_date_description"),
  //   showConfirm: true
  // });

  function openSweetAlert(item, category, index, timetable) {
    setShowAddItem(true);
    setSelectedItem(
      Object.assign({}, item, { category: category, index, timetable })
    );
  }

  // console.log("##################list", list);

  function addToCart(item, quantity, ingredientC, additionalKey, note, hg) {
    // console.log("MUFLO STO AGGIUNGENDO A CARRELLO", {
    //   item,
    //   quantity,
    //   ingredientC,
    //   additionalKey,
    //   note,
    //   hg
    // });
    const dateTime = new Date(
      dateTimeSelected.getFullYear(),
      dateTimeSelected.getMonth(),
      dateTimeSelected.getDate(),
      selectedTime.split(":")[0],
      selectedTime.split(":")[1]
    );

    const dateToAssign = moment(dateTime)
      .format("YYYY-MM-DDTHH:mm:ss")
      .toString();

    // console.log("MUFLO CARRELLO", cart);
    // AGGIUNGI A CARRELLO

    if (item && item.id) {
      if (cart && Array.isArray(cart)) {
        const copyCart = [].concat(cart);

        /* ***********************************************************
        POSSO CALCOLARE L'ID DELLE AGGIUNTE ANDANDO A DIVIDERE ADDITIONALKEY
        ADDITIONALKEY È COMPOSTO DA -->
        $(HG)${TYPE}_${ID_AGGIUNTA}_${ID_ITEM_AGGIUNTA}(${QUANTITY})/...
        ********************************************************** */
        let maxObj = {};
        let maxNumber = 0;
        const allAdd = additionalKey.split("/");

        allAdd.forEach((element) => {
          const [, id] = element.split("_");
          const findEl =
            item && item.add && item.add.find((el) => el._id === id);

          if (findEl && findEl.maxNumber) {
            maxNumber = findEl.maxNumber;
            maxObj = Object.assign({}, maxObj, { [id]: maxNumber });
          }
        });

        // console.log(" LA SEPARAZIONE è", { allAdd, maxNumber, maxObj });

        if (copyCart && copyCart.length > 0) {
          // CERCO SE QUEL BIGLIETTO è GIA' PRESENTE NEL CARRELLO ed è riferito alla stessa data
          // CONTROLLO ANCHE SE AL BIGLIETTO SONO STATE FATTE DELLE MODIFICHE
          // QUESTA FUNZIONE PER LE MODIFICHE ATTUALMENTE NON VIENE USATA

          const findIndexEl = cart.findIndex((el) => {
            return (
              el.productId === item.id &&
              moment(el.dateTimeSelected).isSame(dateToAssign)
            );
          });

          if (findIndexEl >= 0) {
            // SE IL BIGLIETTO ESISTE GIA'

            // SE IL BIGLIETTO ESISTE GIA' AUMENTO LA QUANTITA'
            copyCart[findIndexEl].quantity += quantity || 1;
          } else {
            // SE IL BIGLIETTO NON ESISTE LO METTO NEL CARRELLO
            copyCart.push({
              dateTimeSelected: dateToAssign,
              item: item,
              quantity: quantity,
              price: !Number.isNaN(Number(item.prezzo))
                ? Number(item.prezzo)
                : 0.0,
              productId: item.id,
              ingredientC,
              additionalKey,
              note,
              categoria_articolo: item.categoria_articolo,
              index: item.index,
              information: item.information || [],
            });
          }
        } else {
          // console.log("pusho dentro al carrello", dateToAssign, item);
          copyCart.push({
            dateTimeSelected: dateToAssign,
            item: item,
            quantity: quantity,
            price: !Number.isNaN(Number(item.prezzo))
              ? Number(item.prezzo)
              : 0.0,
            productId: item.id,
            ingredientC,
            additionalKey,
            note,
            categoria_articolo: item.categoria_articolo,
            index: item.index,
            information: [
              /* *****************************************
               IN QUESTO ARRAY VERRANNO SCRITTE LE INFORMAZIONI DI TUTTI I VISITATORI
               ***************************************** */
              // visitatore: {
              //   CAP: "",
              //   nazione: "",
              //   sesso: "",
              //   nascita: null,
              //   codice_biglietto: item.ticketId,
              //   flag_data_aperta: false,
              //   email: shippingInfo.email
              // },
            ],
          });
        }
        updateCart(copyCart);
      }
    }
  }

  // console.log("event selecteddddd", eventSelected);
  // console.log("openings", openings);

  const {
    // totalPrice,
    // servicesFees,
    // deliveryCost,
    // total,
    cartCounter,
    totToShow, // totalPrice + servicesFees + deliveryCost
    // vat
  } = cartParams;

  const componentsContent = (
    <CardBody style={{ marginTop: "20px" }}>
      {list && Object.keys(list) && Object.keys(list).length > 0 ? (
        <div>
          <MenuTypeTimetableContainer />
          {list.map((category) => {
            return (
              <div
                // style={{ backgroundColor: "red" }}
                key={category.id}
              >
                {/* <CardHeader> */}
                <div
                  onClick={() => {
                    // if (
                    //   matches &&
                    //   museum.delivery &&
                    //   museum.delivery.isListMenu
                    // ) {
                    //   if (el && el.categoria_articolo && el.categoria_articolo._id === isOpen) {
                    //     setIsOpen("");
                    //   } else {
                    //     setIsOpen(
                    //       el.categoria_articolo && el.categoria_articolo._id ? el.categoria_articolo._id : ""
                    //     );
                    //   }
                    // }
                  }}
                  style={
                    matches && museum.delivery && museum.delivery.isListMenu
                      ? {
                          // backgroundColor: "rgba(250,250,250,1)",
                          border: "solid 1px rgba(222,222,222,1)",
                          borderRadius: 10,
                          display: "table",
                          padding: "5px",
                          paddingBottom: "10px",
                          marginTop: "5px",
                          marginBottom: "5px",
                          width: "100%",
                        }
                      : {}
                  }
                >
                  <h1
                    className={classes.title}
                    style={{ float: "left", width: "calc(100% - 30px)" }}
                  >
                    {/* {el && el.categoria_articolo && el.categoria_articolo[`label_${language}`]
                      ? el.categoria_articolo[`label_${language}`].toUpperCase()
                      : ""} */}
                    {category.nome_categoria ? category.nome_categoria : ""}
                  </h1>
                  {matches && museum.delivery && museum.delivery.isListMenu ? (
                    <div
                      style={{
                        width: "30px",
                        textAlign: "center",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      {category &&
                      category.categoria_articolo &&
                      category.categoria_articolo._id === isOpen ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </div>
                  ) : null}
                </div>
                {/* </CardHeader> */}

                <GridContainer>
                  {category.articoli
                    ? category.articoli.map((item, ind) => {
                        const itemToSend = {
                          disponibilita: 9999999999,
                          id: item.id,
                          nome: item.nome_articolo,
                          prezzo: item.prezzo_articolo,
                          schema_eventi: item,
                        };
                        // let dateToAssign =
                        //   moment(dateTimeSelected)
                        //     .format("YYYY-MM-DDTHH:mm:ss")
                        //     .toString();
                        let dateTime = null;
                        if (dateTimeSelected && selectedTime) {
                          dateTime = new Date(
                            dateTimeSelected.getFullYear(),
                            dateTimeSelected.getMonth(),
                            dateTimeSelected.getDate(),
                            selectedTime.split(":")[0],
                            selectedTime.split(":")[1]
                          );
                        }

                        const dateToAssign = moment(dateTime)
                          .format("YYYY-MM-DDTHH:mm:ss")
                          .toString();
                        itemToSend.schema_eventi.ora_inizio = dateToAssign;
                        itemToSend.museumTicket = true;
                        return (
                          <ItemTicketType
                            key={item.id}
                            item={itemToSend}
                            currency={currency}
                            language={language}
                            customStyle={customStyle}
                            category={category}
                            index={ind}
                            openSweetAlert={openSweetAlert}
                            addToCart={addToCart}
                            updateCart={updateCart}
                            cart={cart}
                            availablePlaces={999999999}
                            setShowPlacesWarning={setShowPlacesWarning}
                            dateTimeSelected={dateToAssign}
                            eventSelected={eventSelected}
                          />
                        );
                      })
                    : null}
                </GridContainer>
              </div>
            );
          })}
        </div>
      ) : null}
    </CardBody>
  );

  // function onCancel() {
  //   setSelectedItem({});
  //   setShowAddItem(false);
  // }

  // function onConfirm(item, quantity, ingredientC, note, hg) {
  //   // setSelectedItem({});
  //   // setShowAddItem(false);
  //   /* ******************************
  //    DEVO FARE IL SORT DI INGREDIENT C
  //   ******************************* */
  //   // console.log("ON CONFIRM IS", {
  //   //   item,
  //   //   quantity,
  //   //   ingredientC,
  //   //   note,
  //   //   hg
  //   // });
  //
  //   const ordered = {};
  //   const copyIngredientC = JSON.parse(JSON.stringify(ingredientC));
  //   let additionalKey = ``;
  //   Object.keys(copyIngredientC)
  //     .sort()
  //     .forEach(function(key) {
  //       ordered[key] = copyIngredientC[key];
  //       additionalKey += key;
  //     });
  //   if (ordered) {
  //     Object.keys(ordered).forEach(e => {
  //       function compare(a, b) {
  //         // Use toUpperCase() to ignore character casing
  //         const idA = a._id;
  //         const idB = b._id;
  //
  //         let comparison = 0;
  //         if (idA > idB) {
  //           comparison = 1;
  //         } else if (idA < idB) {
  //           comparison = -1;
  //         }
  //         return comparison;
  //       }
  //
  //       ordered[e].sort(compare);
  //
  //       /* **********************************
  //       CREO ADDITIONALKEY PER SCOPRIRE SE LO
  //       STESSO ARTICOLO CON LE STESSE CORREZIONI
  //       DI UGUALE QUANTITÀ È GIÀ PRESENTE NEL
  //       CARRELLO --> SONO NECESSARI GLI ID PER
  //       OGNI ARTICOLO E PER OGNI CORREZIONE EFFETTUATA
  //       ************************************* */
  //
  //       additionalKey += "";
  //     });
  //   }
  //   /* ******************************
  //    FINE SORT DI INGREDIENT C
  //   ******************************* */
  //   addToCart(item, quantity, ordered, additionalKey, note, hg);
  //   onCancel();
  // }

  const convertDayToString = {
    0: "domenica",
    1: "lunedi",
    2: "martedi",
    3: "mercoledi",
    4: "giovedi",
    5: "venerdi",
    6: "sabato",
  };

  // function getCustomAdd() {
  //   /* ***************************************************
  //   NEL CASO SI VOGLIA GESTIRE DELLE AGIUNTE CUSTOM
  //   **************************************************** */
  //   return [];
  // }
  // console.log("color######", eventSelected);

  return (
    <div
      style={{
        backgroundColor: museum?.customizations?.eventDetailsBgColor
          ? museum?.customizations?.eventDetailsBgColor
          : "#ffffff",
      }}
    >
      <style>
        {`.MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected {
          background-color: ${
            museum?.customizations?.museumInfoBgColor
              ? museum?.customizations?.museumInfoBgColor
              : "#000"
          } !important
        }`}
      </style>
      <MobileWrapper
        type={"contacts"}
        showButtons={!!(cartCounter && cartCounter > 0)}
        containerClasses={classes.eventListContainer}
        containerMobileButton={classes.containerMobileButtonMenu}
        buttons={[
          {
            // l'errore potrebbe essere qui, visto che desktop funziona
            onClick: () => {
              history.push(`/${museum.identificativo}/contacts`);
            },
            color: "warning",
            text: t("cart.go_to_cart"),
            isActive: true,
            isLinkActive: true,
            path: `../contacts`,
            customStyle: { backgroundColor: customStyle.buttonCart },
            leftComponent: (
              <>
                {cartCounter ? (
                  <span style={{ verticalAlign: "super" }}>
                    <span className={classes.notifications}>
                      <span>{cartCounter}</span>
                    </span>
                  </span>
                ) : null}
              </>
            ),
            rightComponent: (
              <span className={classes.littlePrice}>
                {totToShow ? totToShow.toFixed(2) : ""}
                <span style={{ paddingRight: "2px", color: "white" }}>
                  {totToShow && currency && currency.symbol
                    ? currency.symbol
                    : ""}
                </span>
              </span>
            ),
          },
        ]}
      >
        <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <NavBarEvent
            logoUrl={museum?.logo_light?.url}
            bgColor={
              museum?.customizations?.museumInfoBgColor
                ? museum?.customizations?.museumInfoBgColor
                : "#303030"
            }
          />

          {
            <div
              // href="/list"
              // to={`/${museum.identificativo}/shop/`}
              style={{
                width: "100%",
                backgroundImage: `url(${museum.cover?.url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "300px",
                display: "flex",
                //alignItems: "center",
                padding: "30px",
                flexDirection: "column",
                // justifyContent: "end",
                //textShadow: "3px 2px 15px rgba(0,0,0,0.8)",
                textAlign: "left",
                //marginTop: "100px"
              }}
            ></div>
          }

          <div className={styles.contentContainer}>
            <LeftSideMuseumInfoTickets museum={museum} />

            <div
              className={styles.ticketListContainer}
              style={{
                color: museum?.customizations?.eventDetailsTextColor
                  ? museum?.customizations?.eventDetailsTextColor
                  : "#000000",
              }}
            >
              {/*<Typography
                variant="h4"
                style={{ fontWeight: 600, fontSize: 25 }}
              >
                {t("bookEvent")}
              </Typography>*/}
              <div
                style={{
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <div style={{ float: "left", width: "50%" }}>
                  <DatePicker
                    label={t("selectData")}
                    value={dateTimeSelected}
                    onChange={setDateTimeSelected}
                    shouldDisableDate={
                      (day) =>
                        openings[convertDayToString[moment(day).format("d")]]
                          .flag_chiuso
                      // !events.some(ev => moment(ev.ora_inizio).isSame(day, "day"))
                    }
                    animateYearScrolling
                    format="dd/MM/yyyy"
                  />
                </div>
                {dateTimeSelected && (
                  <div style={{ float: "left", width: "50%" }}>
                    {waiting && (
                      <div
                        style={{
                          padding: "5px",
                          fontSize: "15px",
                          marginTop: "18px",
                        }}
                      >
                        {t("loading")}
                      </div>
                    )}
                    {slots && !waiting && slots.length === 0 && (
                      <div
                        style={{
                          padding: "5px",
                          fontSize: "15px",
                          marginTop: "18px",
                        }}
                      >
                        {t("noResults")}
                      </div>
                    )}
                    {slots && slots.length > 0 && (
                      <select
                        style={{
                          padding: "5px 0",
                          fontSize: "15px",
                          marginTop: "18px",
                          border: "0px",
                          borderBottom: "1px solid #888",
                        }}
                        defaultValue="-"
                        onChange={(e) => {
                          setSelectedTime(e.target.value);
                        }}
                      >
                        <option value="-" disabled default>
                          {t("selectTime")}
                        </option>
                        {slots.map((slot, key) => {
                          return (
                            <option key={key.toString()} value={slot}>
                              {slot}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </div>
                )}
              </div>
              {dateTimeSelected && selectedTime && (
                <>
                  {componentsContent}
                  {cart?.length > 0 && (
                    <Hidden smDown implementation="css">
                      <div className={styles.checkoutButtonContainer}>
                        <Button
                          round={false}
                          size="sm"
                          color="lightBlue"
                          className={classes.buttonBig}
                          style={{
                            backgroundColor: customStyle.buttonAction,
                            maxWidth: "400px",
                            marginBottom: 100,
                            marginTop: 40,
                          }}
                          // color="info"
                          onClick={() =>
                            history.push(`/${museum.identificativo}/contacts`)
                          }
                        >
                          <span className={classes.buttonBigText}>
                            {t("cart.checkout")}
                          </span>
                        </Button>
                      </div>
                    </Hidden>
                  )}
                </>
              )}
              {/* <div className="logo_emma">
                <img src={logo} alt="logo" />
              </div> */}
            </div>
          </div>
        </div>
      </MobileWrapper>
    </div>
  );
}

BaseEventList.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  updateCartParams: PropTypes.func.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  museum: PropTypes.object,
  customStyle: PropTypes.object,
  eventSelected: PropTypes.object,
  updateEventSelected: PropTypes.func,
};

BaseEventList.defaultProps = {
  museum: null,
  customStyle: {},
  eventSelected: null,
};
